export enum RNEvent {
  onBack = 'onBack',
  onError = 'onError',
  appVersion = 'AppVersion',
  QRScannerResult = 'QRScannerResult',
  takePhotosResult = 'photos',
  locationGranted = 'locationGranted',
  locationGained = 'location',
  locationError = 'locationError',
  credentialsSaved = 'SavedCredentials',
  storageSaved = 'storageSaved',
  storageFetched = 'storageFetched',
  storageCleared = 'storageCleared',
  storageError = 'storageError',
  error = 'error',
}

// request from front
export enum RNAction {
  onLog = 'log',
  goBack = 'goBack',
  callQRScanner = 'callQRScanner',
  callQRScannerUI = 'callQRScannerUI',
  stopQRScannerUI = 'stopQRScannerUI',
  callCamera = 'callCamera',
  callLogin = 'callLogin',
  callLocationOn = 'callLocationOn',
  callLocationOff = 'callLocationOff',
  callSmartMerch = 'callSmartMerch',
  getCredentials = 'getCredentials',
  saveInStorage = 'saveInStorage',
  getFromStorage = 'getFromStorage',
  removeFromStorage = 'removeFromStorage',
  clearAllStorage = 'clearAllStorage',
  share = 'share',
  onLogout = 'logout',
}
